<template>
  <div class="month-picker-container">
    <!-- Month Picker at Top -->
    <div class="month-picker">
      <div class="month-picker__header">
        <div class="month-picker__header-title">  
          Select Billing Period Month and Year :
        </div>
        <div class="month-picker__header-buttons">
        <button @click="previousYear" class="month-picker__btn">&lt;&lt;</button>
        <button @click="previousMonth" class="month-picker__btn">&lt;</button>
        <span class="month-picker__display">
          {{ currentDate.toFormat('MMMM yyyy') }}
        </span>
        <button @click="nextMonth" class="month-picker__btn">&gt;</button>
        <button @click="nextYear" class="month-picker__btn">&gt;&gt;</button>
        </div>
      </div>
    </div>
    
    <!-- Date Picker Below -->
    <div class="date-picker-section">
      <date-range-picker
        ref="monthdate_datepicker"
        :startDate="selectedStartDate"
        :endDate="selectedEndDate"
        type="date"
        @date-select="onDateRangeSelect"
      ></date-range-picker>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import DateRangePicker from "@/views/pages/companies/components/DateRangePicker.vue";

export default {
  name: 'MonthPicker',
  components: {
    DateRangePicker
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        date: DateTime.now().startOf('month'),
        formatted: DateTime.now().toFormat('MMMM yyyy')
      })
    }
  },
  data() {
    return {
      months: [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
      ],
      currentDate: DateTime.now().startOf('month'),
      selectedStartDate: DateTime.now().startOf('month'),
      selectedEndDate: DateTime.now().endOf('month'),
      isCustomDateRange: false
    }
  },
  methods: {
    selectMonth(monthIndex) {
      this.currentDate = this.currentDate.set({ month: monthIndex + 1 })
      this.emitChange()
    },
    previousMonth() {
      this.currentDate = this.currentDate.minus({ months: 1 })
      this.updateDatePickerFromMonth()
      this.emitChange()
    },
    nextMonth() {
      this.currentDate = this.currentDate.plus({ months: 1 })
      this.updateDatePickerFromMonth()
      this.emitChange()
    },
    previousYear() {
      this.currentDate = this.currentDate.minus({ years: 1 })
      this.updateDatePickerFromMonth()
      this.emitChange()
    },
    nextYear() {
      this.currentDate = this.currentDate.plus({ years: 1 })
      this.updateDatePickerFromMonth()
      this.emitChange()
    },
    getStartAndEndOfMonth(date) {
      const startOfMonth = date.startOf('month')
      const endOfMonth = date.endOf('month')
      
      return {
        startISO: startOfMonth.toISO(),
        endISO: endOfMonth.toISO()
      }
    },
    emitChange() {
      const { startISO, endISO } = this.getStartAndEndOfMonth(this.currentDate)
      
      this.$emit('update:modelValue', {
        date: this.currentDate,
        monthNumber: this.currentDate.month,
        year: this.currentDate.year,
        startISO,
        endISO,
        startDate: this.currentDate.startOf('month').toFormat('yyyy-MM-dd'),
        endDate: this.currentDate.endOf('month').toFormat('yyyy-MM-dd')
      })
    },
    updateDatePickerFromMonth() {
      // Update date picker to reflect the selected month
      this.selectedStartDate = this.currentDate.startOf('month')
      this.selectedEndDate = this.currentDate.endOf('month')
      this.isCustomDateRange = false
      
      // Update the date range picker component
      if (this.$refs.monthdate_datepicker) {
        this.$refs.monthdate_datepicker.resetDate(this.selectedStartDate, this.selectedEndDate)
      }
    },
    onDateRangeSelect(dateData) {
      // Handle custom date selection from date picker
      this.isCustomDateRange = true
      this.selectedStartDate = DateTime.fromISO(dateData.startDate)
      this.selectedEndDate = DateTime.fromISO(dateData.endDate)
      
      // Update currentDate to match the selected start date
      this.currentDate = this.selectedStartDate.startOf('month')
      
      // Emit the custom date range
      this.$emit('update:modelValue', {
        date: this.selectedStartDate,
        monthNumber: this.selectedStartDate.month,
        year: this.selectedStartDate.year,
        startISO: this.selectedStartDate.toISO(),
        endISO: this.selectedEndDate.toISO(),
        startDate: this.selectedStartDate.toFormat('yyyy-MM-dd'),
        endDate: this.selectedEndDate.toFormat('yyyy-MM-dd'),
        isCustomRange: true
      })
    }
  },
  created() {
    if (this.modelValue?.date) {
      this.currentDate = DateTime.isDateTime(this.modelValue.date) 
        ? this.modelValue.date 
        : DateTime.fromISO(this.modelValue.date)
    }
    this.updateDatePickerFromMonth()
    this.emitChange()
  }
}
</script>

<style scoped lang="scss">
@import './monthPicker.scss';
</style>